import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBonusDisplayFromDefinition } from '~/boggle/config/bonuses/formatResolvedBonusDisplay'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'
import type { BoggleBonusValue } from '../types'
import type { BoggleChallengeBonusDefinition } from '../bonusDefinition'

export const noRepeatsBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word uses each tile at most once',
  id: 'no-repeats',
  name: 'No Repeats',
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: 'Unique tiles',
}

export function resolveNoRepeatsBonus(
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  _context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
): {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} {
  const display = formatResolvedBonusDisplayFromDefinition(family, {})

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [
        {
          kind: 'requires-unique-tiles',
        },
      ],
      parameters: {},
      shortLabel: display.shortLabel,
      value,
    },
    rngState,
  }
}
